import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(
    `${process.env.REACT_APP_API_HOST}/resume_training/`,
    data,
    {
      headers: {
        'Content-Type': `multipart/form-data;`,
      },
    },
  );
};

const get = async (id) => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/resume_training/${id}`,
  );
};

const filter = async (query) => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/resume_training/${query}`,
  );
};

const put = async (id, data) => {
  return await httpClient.put(
    `${process.env.REACT_APP_API_HOST}/resume_training/${id}/`,
    data,
    {
      headers: {
        'Content-Type': `multipart/form-data;`,
      },
    },
  );
};

const remove = async (id) => {
  return await httpClient.delete(
    `${process.env.REACT_APP_API_HOST}/resume_training/${id}`,
  );
};

export { post, get, put, remove, filter };
